<script setup>
import CustomButton from "@/components/Button/Button.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useUserStore } from "@/stores/userStore";
import DeactivateAccount from "@/components/AccountSettings/DeactivateAccount.vue";

const { t } = useI18n();
const userStore = useUserStore();

const feedbackMessage = ref('');
const errorMessage = ref('');

async function handleChangePassword() {
  feedbackMessage.value = '';
  errorMessage.value = '';

  try {
    await userStore.changePassword();
    feedbackMessage.value = t('changePassword.success');
  } catch (error) {
    console.error(error);
    errorMessage.value = t('changePassword.failure');
  }
}

defineEmits(['show-register', 'forgot-password']);
</script>

<template>
  <div class="flex flex-col gap-8 py-10 max-w-[400px]">
    <h1 class="responsive-title-5 font-semibold self-start gap-2 headerText">{{ t('changePassword.title') }}</h1>
    <p class="responsive-body-small text-gray-600">
      {{ t('changePassword.instructions') }}
    </p>

    <div v-if="feedbackMessage" class="text-notifications-confirmed responsive-body-small">{{ feedbackMessage }}</div>
    <div v-if="errorMessage" class="text-notifications-red responsive-body-small">{{ errorMessage }}</div>

    <CustomButton @click="handleChangePassword" size="small" type="black" :outlined="false" :rounded="true" class="w-fit mb-2 py-2 px-4 responsive-body-medium">
      {{ t('changePassword.changePasswordButton') }}
    </CustomButton>
    <hr>
    <div class="mt-2">
      <DeactivateAccount />
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 768px) {
  .btn {
    font-size: 12px;
  }

  .mainContainer {
    padding: 34px 20px;
    width: 100%;
    max-width: 100%;
    gap: 32px;
  }

  .mainContainerX {
    width: 100%;
    max-width: 100%;
    padding: 0 20px;
  }

  .headerText {
    font-size: 20px;
  }
}
</style>